<template>
    <div class="container">
        <v-autocomplete
            v-model="selectedAssignees"
            :items="availableUsers"
            filled
            chips
            color="#0047AB"
            item-color="green"
            label="Επιλογή ατόμων"
            item-value="id"
            multiple
            shaped
        >
            <template v-slot:selection="data">
                <v-chip
                    :color="hasAssigneeAssignments(data.item.id) ? 'rgb(76, 175, 80, 0.6)' : 'gray'"
                    :close="editMode && !hasAssigneeAssignments(data.item.id)"
                    @click="onAssigneeChipClick(data.item)"
                    @click:close="remove(data.item)"
                >
                    <v-icon
                        small
                        color="#ebc334"
                    >
                        mdi-account
                    </v-icon>
                    <div class="assignee-name">{{ data.item.firstName }} {{ data.item.lastName }}</div>
                </v-chip>
            </template>
            <template v-slot:item="data">
                <template v-if="data.item">
                    <v-list-item
                        v-bind="data.attrs"
                        @click="data.on.click"
                    >
                        <v-list-item-content>
                            <v-list-item-title>
                                <div class="assignee-name">{{ data.item.firstName }} {{ data.item.lastName }}</div>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-chip
                                v-for="role in data.item.roles"
                                :key="role.role"
                                small
                                :color="getRoleColor(role.role)"
                                class="role-chip"
                            >
                                {{ getRoleText(role) }}
                            </v-chip>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </template>
        </v-autocomplete>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="750"
        >
            <v-card v-if="selectedAssignee">

                <v-card-title class="text-h5 card-title">
                    <div class="assignee-name">
                        {{ selectedAssignee.firstName }} {{ selectedAssignee.lastName }}
                        <v-chip-group
                            active-class="primary--text"
                            class = "group-chips"
                        >
                            <v-chip
                                v-for="role in selectedAssignee.roles"
                                :key="role.role"
                                :color="getRoleColor(role.role)"
                                class="role-chip"
                                disabled
                            >
                                {{ getRoleText(role) }}
                            </v-chip>
                        </v-chip-group>
                    </div>
                    <div v-if="selectedAssignee.contractor" class="contractor-name">@{{ selectedAssignee.contractor.name }}</div>
                </v-card-title>
                <v-card-text>Ορισμός εργασιών σε ημέρα</v-card-text>
                <div v-if="editMode" class="work-assignment-wrapper">
                    <v-select
                        v-model="selectedWork"
                        :items="remainingWorkTaskTypes"
                        return-object
                        item-text="name"
                        label="Εργασία"
                        class="field mx-4"
                    ></v-select>
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        left
                        min-width="300"
                        class="field"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="greekDatetime"
                                class="field mx-4"
                                label="Στις"
                                prepend-icon="mdi-calendar"
                                readonly
                                @click:clear="() => {
                                    date = null
                                    time = null }"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            color="#0047AB"
                            :min="getGreekDate(new Date())"
                            :disabled="!editMode"
                            locale="el"
                        ></v-date-picker>
                        <v-time-picker
                            v-model="time"
                            color="#0047AB"
                            format="24hr"
                            :readonly="!editMode"
                            scrollable
                            :disabled="!editMode || !date"
                        ></v-time-picker>
                    </v-menu>
                    <v-btn
                        class="addition-btn mx-4 my-4"
                        outlined
                        color="green"
                        small
                        :disabled="!dateTime || !selectedWork"
                        @click="addTaskAssignmentForUser()"
                    >
                        <v-icon small>mdi-plus</v-icon>
                        ΠΡΟΣΘΗΚΗ
                    </v-btn>
                </div>
                <v-divider class="my-2" />
                <div>
                    <div v-for="(taskAssignment, index) in taskAssignments" :key="index" class="assigned-work">
                        <v-icon
                            large
                            color="black"
                        >
                            mdi-menu-right
                        </v-icon>
                        {{ getTypeText(taskAssignment.type) }}
                        <div class="datetime-wrapper">
                            <v-icon
                                large
                                color="#0047AB"
                                class="mx-2"
                            >
                                mdi-ray-start-arrow
                            </v-icon>
                            <div v-if="taskAssignment.finalDatetime">
                                {{ getGreekDateTime(taskAssignment.finalDatetime) }}
                            </div>
                            <div v-else class="desired-datetime">
                                {{ getGreekDateTime(taskAssignment.datetime) }}
                            </div>
                            <v-btn
                                v-if="editMode"
                                class="subsctruction-btn"
                                outlined
                                color="red"
                                x-small
                                fab
                                @click="removeTaskAssignmentFromUser(taskAssignment)"
                            >
                                <v-icon>mdi-minus</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red white--text"
                        @click="onCalcel"
                    >
                        ΑΚΥΡΩΣΗ
                    </v-btn>
                    <v-btn
                        :disabled="!editMode"
                        color="black white--text"
                        @click="onSubmit"
                    >
                        ΥΠΟΒΟΛΗ
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import momentTimezone from 'moment-timezone'
    import userService from '@/services/user'
    import userMixin from '@/mixins/user'

    export default {
        mixins: [ userMixin ],
        props: {
            alreadyAssignedTasks: {
                type: Map,
                required: true,
                default: () => { return new Map() }
            },
            editMode: {
                type: Boolean,
                required: true
            },
            contractorId: {
                type: Number,
                required: false,
                default: () => { return null }
            },
            alreadyAssignedTasksLength: {
                type: Number,
                required: true
            },
            assignmentTabs: {
                type: Array,
                required: true
            }
        },
        watch: {
            alreadyAssignedTasksLength: {
                handler() {
                    this.initSelectedAssignees()
                    this.taskAssignmentsMap = new Map()
                },
                immediate: true
            },
            contractorId: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.availableUsers = this.allUsers.filter(user => user.contractor?.id === newVal || this.isUserAdmin(user) || this.selectedAssignees.find(selectedUser => selectedUser.id === user.id))
                    } else {
                        this.availableUsers = this.allUsers.filter(user => this.selectedAssignees.find(selectedUser => selectedUser.id === user.id))
                    }
                },
                immediate: true
            },
            remainingWorkTaskTypes: {
                handler() {
                    if (this.remainingWorkTaskTypes.length === 1) {
                        this.selectedWork = this.remainingWorkTaskTypes[0]
                    }
                }
            }
        },
        computed: {
            // selectedAssigneeTaskTypes() {
            //     if ((!this.selectedAssignee && !this.selectedAssignee.roles) || !this.dialog) {
            //         return []
            //     }
            //     let types = []
            //     for (const role of this.selectedAssignee.roles) {
            //         types = types.concat(this.getTaskTypesForRole(role.role))
            //     }
            //     return types
            // },
            config() {
                return this.$store.getters.getConfig || {}
            },
            taskTypes() {
                return this.config?.taskTypes || []
            },
            dateTime() {
                return (this.date ? this.date : '') + (this.time ? ' ' + this.time : '')
            },
            greekDatetime() {
                return this.dateTime ? this.getGreekDateTime(this.dateTime) : ''
            },
            remainingWorkTaskTypes() {
                if (!this.dialog || !this.selectedAssignee) {
                    return []
                }
                return this.taskTypes.filter(taskType => !this.alreadySelectedWorkTaskTypes.includes(taskType.value) && this.assignmentTabs.includes(taskType.value.toLowerCase()))
            },
            alreadySelectedWorkTaskTypes() {
                return this.taskAssignments.map(taskAssignment => taskAssignment.type)
            }
        },
        data: () => {
            return {
                taskAssignments: [],
                alreadyAssignedTasksTemp: new Map(),
                taskAssignmentsMap: new Map(),
                selectedWork: null,
                selectedAssignees: [],
                selectedAssignee: {},
                allUsers: [],
                availableUsers: [],
                assigneeId: null,
                dialog: false,
                menu: false,
                date: null,
                time: null,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ]
            }
        },
        created() {
            userService.getAllUsers().then(resp => {
                this.allUsers = resp.data.filter(user => {
                    const roles = user.roles.map(role => role.role)
                    return !roles.includes('ROLE_COORDINATOR') || roles.length > 1
                })
                if (this.contractorId) {
                    this.availableUsers = this.allUsers.filter(user => user.contractor?.id === this.contractorId || this.isUserAdmin(user) || this.selectedAssignees.find(selectedUser => selectedUser.id === user.id))
                } else {
                    this.availableUsers = this.allUsers.filter(user => this.selectedAssignees.find(selectedUser => selectedUser.id === user.id))
                }
            })
        },
        methods: {
            isUserAdmin(user) {
                const roles = user.roles.map(role => role.role)
                return roles.includes('ROLE_ADMIN')
            },
            clearSelected() {
                this.selectedAssignees = []
            },
            getTypeText(type) {
                return this.taskTypes.find(taskType => taskType.value === type).name || ''
            },
            initSelectedAssignees() {
                this.selectedAssignees = []
                this.alreadyAssignedTasks.values().forEach(value => { this.selectedAssignees.push(value[0].assignee) })
                this.alreadyAssignedTasksTemp = this.alreadyAssignedTasks
            },
            hasAssigneeAssignments(assigneeId) {
                const assigneeAssignmentsCount = (this.alreadyAssignedTasksTemp.get(assigneeId) || []).concat(this.taskAssignmentsMap.get(assigneeId) || []).length
                return (assigneeAssignmentsCount > 0)
            },
            onAssigneeChipClick(assignee) {
                this.selectedAssignee = assignee
                this.taskAssignments = []
                this.taskAssignments = (this.alreadyAssignedTasksTemp.get(assignee.id) || []).concat(this.taskAssignmentsMap.get(assignee.id) || [])
                this.dialog = true
            },
            remove(assignee) {
                const index = this.selectedAssignees.findIndex(a => a === assignee.id)
                if (index >= 0) {
                    this.selectedAssignees.splice(index, 1)
                    this.reset()
                    this.$emit('task-assignment-submited', assignee.id, [])
                }
            },
            getRoleText(role) {
                return role.role.split('ROLE_')[1]
            },
            getGreekDateTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            getGreekDate(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            getGreekTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('HH:mm').toString()
            },
            removeTaskAssignmentFromUser(taskAssignment) {
                if (taskAssignment.id) {
                    let alreadyTasks = this.alreadyAssignedTasksTemp.get(this.selectedAssignee.id)
                    const index = alreadyTasks.findIndex(task => task.id === taskAssignment.id)
                    alreadyTasks.splice(index, 1)
                    this.alreadyAssignedTasksTemp.set(this.selectedAssignee.id, alreadyTasks)
                } else {
                    let tempTasks = this.taskAssignmentsMap.get(this.selectedAssignee.id)
                    const index = tempTasks.findIndex(task => task.type === taskAssignment.type)
                    tempTasks.splice(index, 1)
                    this.taskAssignmentsMap.set(this.selectedAssignee.id, tempTasks)
                }
                const index = this.taskAssignments.indexOf(taskAssignment)
                this.taskAssignments.splice(index, 1)
            },
            onCalcel() {
                this.reset()
                this.dialog = false
            },
            onSubmit() {
                this.$emit('task-assignment-submited', this.selectedAssignee.id, this.taskAssignments)
                this.reset()
                this.dialog = false
            },
            reset() {
                this.date = null
                this.time = null
                this.selectedAssignee = null
                this.selectedWork = null
                this.taskAssignments = []
            },
            addTaskAssignmentForUser() {
                const taskAssignment = {
                    assignee: this.selectedAssignee,
                    datetime: momentTimezone(this.dateTime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString(),
                    type: this.selectedWork.value
                }
                this.taskAssignments.push(taskAssignment)
                const alreadyTempTasks = this.taskAssignmentsMap.get(this.selectedAssignee.id) || []
                alreadyTempTasks.push(taskAssignment)
                this.taskAssignmentsMap.set(this.selectedAssignee.id, alreadyTempTasks)
                this.date = null
                this.time = null
                this.selectedWork = null
            }
        }
    }
</script>
<style scoped>
.assignee-name {
    font-weight: 500;
}
.datetime-wrapper {
    display: flex;
    align-items: center;
}
.desired-datetime {
    color: rgb(240, 188, 104);
}
.container {
    width: 100%;
}

.role-chip {
    color: white;
}

.v-chip--disabled {
    opacity: 1;
}

.card-title {
    display: flex;
    justify-content: space-between;
}
.assignee-name {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.group-chips {
    margin-left: 0.6rem;
}
.work-assignment-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.field {
    max-width: 280px;
}

.assigned-work {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 1rem;
}

.subsctruction-btn {
    align-self: center;
    margin: 0.5rem;
}
.contractor-name {
    font-size: 1.3rem;
}
</style>
<style>
.v-menu__content {
    scrollbar-width: thin !important;
    scrollbar-color: #888 white;
}
</style>
